import React from "react";
import { useTable, useSortBy } from "react-table";
import {
  Icon,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { actionButtonStyle } from "components/CenterDashboardSection/style";

const WorkshopAttendedTable = ({ data }) => {
  console.log("WorkshopAttendedTable");
  const [searchText, setSearchText] = React.useState("");
  const columnClassMap = {
    workshopName: "workshop-table__row__workshop_name",
    duration: "workshop-table__row__duration",
    description: "workshop-table__row__description",
    date_time_start: "workshop-table__row__date_time_start",
    location: "workshop-table__row__location",
    trainer: "workshop-table__row__trainer",
    action: "workshop-table__row__action",
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Workshop Name",
        accessor: "workshopName",
        align: "left",
        width: "15%",
        isSort: true,
        minWidth: 250,
      },
      {
        Header: "Duration",
        accessor: "duration",
        align: "left",
        width: "10%",
        isSort: true,
      },
      {
        Header: "Description",
        accessor: "description",
        align: "left",
        width: "40%",
        isSort: true,
        minWidth: 400,
      },
      {
        Header: "Date & Time",
        accessor: "date_time_start",
        align: "left",
        width: "18%",
        isSort: true,
        minWidth: 200,
      },
      {
        Header: "Location",
        accessor: "location",
        align: "left",
        width: "15%",
        isSort: true,
      },
      {
        Header: "Trainer",
        accessor: "trainer",
        align: "left",
        width: "10%",
        isSort: true,
        minWidth: 150,
      },
      {
        Header: "Action",
        accessor: "action",
        align: "left",
        width: "200px",
        Cell: ({ row }) => (
          <MDButton
            key={row.id}
            sx={(theme) => ({
              ...actionButtonStyle(theme),
            })}
          >
            <Icon sx={{}}>visibility</Icon>
            View&nbsp;Resources
          </MDButton>
        ),
      },
    ],
    []
  );

  const filteredData = React.useMemo(() => {
    if (!searchText) return data;
    return data.filter((row) =>
      row.workshopName.toLowerCase().includes(searchText.toLowerCase())
    );
  }, [data, searchText]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state: { sortBy },
  } = useTable(
    {
      columns,
      data: filteredData,
    },
    useSortBy
  );

  return (
    <MDBox className="workshop-table-attended-container">
      <MDBox className="data-table-controls">
        <MDBox className="workshop__table-filters">
          <MDInput
            className="input input-search"
            placeholder="Search here..."
            name="keyword"
            value={searchText}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon className="icon-search" />
                </InputAdornment>
              ),
            }}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </MDBox>
        <TableContainer>
          <Table {...getTableProps()} className="workshop-table">
            <TableHead className="workshop-table__header_group">
              {headerGroups.map((headerGroup, index) => (
                <TableRow
                  key={index}
                  className="workshop-table__header"
                  {...headerGroup.getHeaderGroupProps()}
                >
                  {headerGroup.headers.map((column, index) => (
                    <TableCell
                      key={index}
                      className="workshop-table__header-cell"
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                      style={{
                        width: column.width,
                        minWidth: column.minWidth,
                        textAlign: column.align,
                        color: "#172B4D",
                        fontStyle: "normal",
                        fontWeight: 500,
                      }}
                    >
                      {column.render("Header")}
                      {column.isSort ? (
                        <span>
                          {column.isSorted
                            ? column.isSortedDesc
                              ? " ▼"
                              : " ▲"
                            : ""}
                        </span>
                      ) : null}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableHead>
            <TableBody {...getTableBodyProps()}>
              {rows.map((row) => {
                prepareRow(row);
                return (
                  <React.Fragment key={row.id}>
                    {/* Main row */}
                    <TableRow
                      className="workshop-table__row"
                      {...row.getRowProps()}
                    >
                      {row.cells.map((cell, index) => {
                        const columnId = cell.column.id;
                        const cellClass =
                          columnClassMap[columnId] || "workshop-table__default";
                        return (
                          <TableCell
                            key={index}
                            className={`workshop-table__cell ${cellClass}`}
                            {...cell.getCellProps()}
                          >
                            {cell.render("Cell")}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  </React.Fragment>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </MDBox>
    </MDBox>
  );
};

export default WorkshopAttendedTable;
